import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';
import { unwrapResult } from '@reduxjs/toolkit';
import { Form, Input } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import Snackbars from '../../../../../GlobalComponents/Alerts/Snackbars';
import GridContainer from '../../../../../GlobalComponents/Grid/GridContainer';
import GridItem from '../../../../../GlobalComponents/Grid/GridItem';
import H4 from '../../../../../GlobalComponents/TypoGraphy/H4';
import { Colors } from '../../../../../GlobalComponents/Utility/Colors';
import {
  internalUpdateStatutTicket
} from '../../../../../ReduxTLK/features/SAV/TicketSlice';
import { getAllowedTargetTeams } from '../../../../../utils/escaladeUtils';
import TeamSelector from '../../../../Escalade/TeamSelector';



// ─── Modal : Changer d'équipe (PUT avec type) — Dev → IT uniquement
function ChangeTeamModal({ open, onClose, activeInternalStatus, ticketId, onSuccess }) {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const dispatch = useDispatch();
  const allowedTeams   = getAllowedTargetTeams(activeInternalStatus?.type);
  const [selectedType, setSelectedType] = useState(allowedTeams[0]?.type ?? null);
  const [msg, setMsg]       = useState('');
  const [success, setSuccess] = useState(false);
  const [error,   setError]   = useState(false);

  const handleClose = () => { form.resetFields(); onClose(); };

  const handleFinish = async (values) => {
    const body = { id: activeInternalStatus?.id, ticketId, type: selectedType, description: values.description };
    try {
      await dispatch(internalUpdateStatutTicket(body)).then(unwrapResult);
      setMsg('Équipe mise à jour'); setSuccess(true);
      handleClose(); onSuccess();
    } catch { setMsg("Un problème est survenu."); setError(true); }
  };

  return (
    <>
      <Dialog open={open} fullWidth maxWidth="sm" sx={{ '& .MuiPaper-root': { borderRadius: '12px' } }}>
        <DialogTitle>
          <GridContainer>
            <GridItem sx={11.5} sm={11.5} md={11.5} xl={11.5} xxl={11.5}><H4 title="Changer d'équipe" /></GridItem>
            <GridItem sx={0.5} sm={0.5} md={0.5} xl={0.5} xxl={0.5}>
              <IconButton onClick={handleClose} sx={{ color: Colors.primary }}><CloseIcon /></IconButton>
            </GridItem>
          </GridContainer>
        </DialogTitle>

        <Form form={form} name="change-team" onFinish={handleFinish}>
          <GridContainer display="flex" justifyContent="center" direction="row" gap="8px" flex="1 0 0">
            <GridItem sx={12} sm={12} md={12} xl={12} xxl={12} padding="16px 32px 0px 32px">

              <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#333', mb: 1.5 }}>
                Nouvelle équipe cible
              </Typography>
              <TeamSelector teams={allowedTeams} selectedType={selectedType} onSelect={setSelectedType} />

              <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#333', mb: 1 }}>
                Description <span style={{ color: 'red' }}>*</span>
              </Typography>
              <Form.Item name="description" rules={[{ required: true, message: 'Ce champ est obligatoire !' }]}>
                <TextArea rows={4} autoSize={{ minRows: 4, maxRows: 4 }} placeholder="Raison du changement d'équipe..." />
              </Form.Item>

            </GridItem>
          </GridContainer>

          <DialogActions>
            <Form.Item style={{ marginTop: '-25px' }}>
              <Button onClick={handleClose} variant="outlined"
                sx={{ textTransform: 'none', border: '2px solid #2A66C6', color: '#2A66C6', borderRadius: '18px', width: '93px', height: '40px' }}>
                Annuler
              </Button>
              <Button type="submit" variant="contained" disabled={selectedType === null}
                sx={{ textTransform: 'none', '&.MuiButtonBase-root': { color: '#fff', backgroundColor: '#2A66C6', borderRadius: '32px', height: '40px', width: '160px', minWidth: '100px', ml: 2, mr: 3, boxShadow: '0px 1px 2px 0px rgba(16,24,40,0.05)', '&:hover': { backgroundColor: '#3C3489' } } }}>
                Confirmer
              </Button>
            </Form.Item>
          </DialogActions>
        </Form>
      </Dialog>
      <Snackbars severity="success" message={msg} open={success} setOpen={setSuccess} autohideduration={2000} />
      <Snackbars severity="error"   message={msg} open={error}   setOpen={setError}   autohideduration={3000} />
    </>
  );
}

export default ChangeTeamModal;